// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const ellipse = "PieChart__ellipse__Hpm6Y";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const sector = "PieChart__sector__qOnJJ";
export const semibold = "600";
export const serif = "'serif'";
export const shaded = "PieChart__shaded__MpDNV";
export const shown = "PieChart__shown__6jp06";
export const text = "PieChart__text__H8VCI font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const tooltip = "PieChart__tooltip__tr9Sb";